/** Bağlantı tipleri: weld.joint'in mevcut üç değeri (S4 değerleri değişmez). */
export const BAGLANTILAR = ["Box to pipe butt", "Pipe to pipe butt", "Pin to pipe butt"];
export const BOX_BAGLANTI = "Box to pipe butt";
export const BORU_BAGLANTI = "Pipe to pipe butt";
export const PIN_BAGLANTI = "Pin to pipe butt";
/** Aralık → a−300 ve b+300 mm kesim (varsayım, Soru 4). */
export const KESIM_PAYI_MM = 300;
/** Nokta → p±500 mm kesim; nokta kusur bandının yarıçapı da budur (|x−p| < 500 = bandın içi). */
export const NOKTA_PAYI_MM = 500;
/** Flanş kaynağına < 500 mm kesim → "Cut at … flange weld" önerisi. */
export const FLANS_ESIGI_MM = 500;
/** İki parça arasında < 4000 mm sağlam boru → "Merge" önerisi. */
export const BIRLESTIRME_ESIGI_MM = 4000;
/** 500 mm'den kısa artık uyarısı. */
export const KISA_ARTIK_MM = 500;
/** Boy varsayılanı 75 ft = 22.860 mm (Bekir 30.09.2026, R002 MRB O.A.L. 75'). */
export const VARSAYILAN_BOY_MM = 22860;
/** Kesim rotaları: ST-03 ve ST-06 → MB, ST-04 ve ST-05 → CKB; H (hidrolik) aynı kaynak zincirini taşır. */
export const KESIM_ROTALARI = ["MB", "CKB", "H"];
/** Kesim rotası: tamir tipli ST ve rota kodu MB/CKB/H (ST-03, ST-04, ST-05, ST-06; ST-11 degisim tipli olduğu için hayır). */
export function kesimRotasiMi(st) {
    return Boolean(st) && st.tip === "repair" && KESIM_ROTALARI.includes(st.rotaKod);
}
/** ST-03 boru · ST-04 flans · ST-05 kaynak_tamiri · ST-06 flans_kurtarma · başka her kod boru. */
export function kesimTuru(stKod) {
    if (stKod === "ST-04")
        return "flans";
    if (stKod === "ST-05")
        return "kaynak_tamiri";
    if (stKod === "ST-06")
        return "flans_kurtarma";
    return "boru";
}
const boxMu = (b) => b === BOX_BAGLANTI;
const pinMi = (b) => b === PIN_BAGLANTI;
const etkinMi = (s) => s.durum === "onayli";
/** D-055: yeni borunun ek kaynağı satırı (kesim değil). */
export const ekKaynagiMi = (s) => s.tur === "ek_kaynagi";
/**
 * D-070: beyanlı satır: etkin, "No distance record available" işaretli, mesafesi boş ve ya ek kaynağı ya da Pipe to pipe butt
 * bağlantılı kesim. Box / Pin satırı (mesafesi boru referansıdır) ve kaynak tamiri satırı beyan taşımaz. Mesafe sonradan girilince
 * satır beyanlı olmaktan çıkar (veritabanındaki beyan damgası tarih olarak kalır).
 */
export const mesafeBeyanliMi = (s) => etkinMi(s) && s.mesafeKayitYok === true && s.mesafeMm === null && (ekKaynagiMi(s) || (s.tur === "kesim" && s.baglanti === BORU_BAGLANTI));
/** D-070: planda beyanlı satır varsa kaynak numarası önerilmez (bilinmeyen kaynağın sırası da bilinmez); numaralar elle girilir. */
export const numaraOnerilmezMi = (t) => t.kesimler.some(mesafeBeyanliMi);
/** D-070: beyanlı satırlardan biri kesimse kesim yerleri eksiktir: parçalar, eşleşme ve yeni boru boyu türetilmez. */
export const kesimKonumuEksikMi = (t) => t.kesimler.some((s) => s.tur === "kesim" && mesafeBeyanliMi(s));
/** Box ucundan konumun alt ve üst sınırı: box flanş kaynağı (yoksa 0) ve pin flanş kaynağı (yoksa boy, o da yoksa 22.860). */
const boxKonumu = (r) => r.box ?? 0;
const pinKonumu = (r) => r.pin ?? r.boy ?? VARSAYILAN_BOY_MM;
export const varsayilanEtiket = (sira) => `C${sira}`;
/** D-055: tek satırın etiketi: kesim ve kaynak tamiri "C{sira}", yeni boru ek kaynağı "S{sira}". */
export const satirAdi = (s) => `${ekKaynagiMi(s) ? "S" : "C"}${s.sira}`;
/** D-055: planın satır etiketi; planda olmayan sıra "C{sira}". */
export function satirEtiketi(t) {
    const ekler = new Set(t.kesimler.filter(ekKaynagiMi).map((s) => s.sira));
    return (sira) => `${ekler.has(sira) ? "S" : "C"}${sira}`;
}
/** Sıralama/konum: Box → ref.box ?? 0; Pin → ref.pin ?? ref.boy ?? VARSAYILAN_BOY_MM; Pipe to pipe → mesafe. */
export function kesimKonumu(s, r) {
    if (boxMu(s.baglanti))
        return boxKonumu(r);
    if (pinMi(s.baglanti))
        return pinKonumu(r);
    return s.mesafeMm;
}
/**
 * Konum sırası: konum (boşsa en sona), eşitlikte Box → Pipe to pipe → Pin, kesim → kaynak tamiri → ek kaynağı, sonra sıra.
 * D-055: mesafesiz ek kaynağı `ekKonumu`nda sayılır (verilmezse en sona).
 */
function konumSirasi(r, ekKonumu = null) {
    const grup = (b) => (boxMu(b) ? 0 : pinMi(b) ? 2 : 1);
    const turSirasi = (t) => (t === "kesim" ? 0 : t === "kaynak_tamiri" ? 1 : 2);
    const konum = (s) => (ekKaynagiMi(s) && s.mesafeMm === null ? ekKonumu : kesimKonumu(s, r)) ?? Number.POSITIVE_INFINITY;
    return (a, b) => {
        const ka = konum(a);
        const kb = konum(b);
        if (ka !== kb)
            return ka < kb ? -1 : 1;
        return grup(a.baglanti) - grup(b.baglanti) || turSirasi(a.tur) - turSirasi(b.tur) || a.sira - b.sira;
    };
}
/**
 * D-055: mesafesiz ek kaynağının kaynak numarası sıralamasındaki ve şemadaki konumu: ilk değişecek parçanın ortası; parça yoksa
 * box ile pin flanş kaynağının (referans boşsa box ucu ile boyun) ortası. R034 boydan boya: 0–22.860 → 11.430 (W1 box, W2 ek, W3 pin).
 */
export function ekKaynagiKonumu(t) {
    const p = parcalariKur(t).parcalar[0];
    return p ? (p.bas + p.son) / 2 : (boxKonumu(t.referans) + pinKonumu(t.referans)) / 2;
}
/**
 * D-055: satırın şemadaki konumu: kesimKonumu; mesafesiz ek kaynağında ekKaynagiKonumu. D-070: beyanlı satırın (kesim ya da ek
 * kaynağı) konumu yoktur, çizilmez; beyansız mesafesiz ek kaynağı bugünkü gibi sıralama konumunda çizilir.
 */
export function satirKonumu(t, s) {
    if (mesafeBeyanliMi(s))
        return null;
    return ekKaynagiMi(s) && s.mesafeMm === null ? ekKaynagiKonumu(t) : kesimKonumu(s, t.referans);
}
const bosa = (s) => {
    const t = (s ?? "").trim();
    return t === "" ? null : t;
};
/**
 * Box/Pin satırının mesafesini referansa eşitler, ara[]'yı sıralar/tekilleştirir, not/gerekçe trim ('' → null), iptalde
 * kaynakNo = null (etkin satırda iptalNedeni null, iptal satırında boşsa "iptal"). D-055: ek kaynağı satırının bağlantısı hep
 * Pipe to pipe butt (gövdede başka bağlantı gelse de). Satırlar siraya göre dizilir. Saf, yeni nesne döner.
 * D-070: `mesafeKayitYok` yalnız normalleşmiş satır beyanlıysa `true` olarak kalır; flanş satırında, kaynak tamirinde, iptal edilen
 * satırda ve mesafesi olan satırda anahtar satırdan ÇIKARILIR (tanımsız bırakılmaz), işaretsiz planın satırları bugünkü alanları taşır.
 */
export function kesimleriNormallestir(t) {
    const r = t.referans;
    const referans = { box: r.box, ara: [...new Set(r.ara)].sort((a, b) => a - b), pin: r.pin, boy: r.boy };
    const kesimler = [...t.kesimler]
        .sort((a, b) => a.sira - b.sira)
        .map((s) => {
        const etkin = etkinMi(s);
        const baglanti = ekKaynagiMi(s) ? BORU_BAGLANTI : s.baglanti;
        const mesafeMm = boxMu(baglanti) ? referans.box : pinMi(baglanti) ? referans.pin : s.mesafeMm;
        const { mesafeKayitYok, ...kalan } = s;
        const satir = { ...kalan, baglanti, mesafeMm, not: bosa(s.not), iptalNedeni: etkin ? null : (s.iptalNedeni ?? "iptal"), kaynakNo: etkin ? s.kaynakNo : null };
        return mesafeBeyanliMi({ ...satir, mesafeKayitYok }) ? { ...satir, mesafeKayitYok: true } : satir;
    });
    return { referans, kesimYok: t.kesimYok, gerekce: bosa(t.gerekce), kesimler };
}
/**
 * Etkin satırların (onayli) otomatik kaynak numaraları: konuma göre box'tan 1…n (Box önce, Pin sonra; eşitlikte sıra). Anahtar sira.
 * D-055: mesafesiz ek kaynağı ekKaynagiKonumu'nda sayılır (boydan boyada iki flanş kaynağının arasında).
 * D-070: planda beyanlı satır varsa hiçbir satıra numara önerilmez (boş eşleme): yeri bilinmeyen kaynak her yerde olabilir, öteki
 * kaynakların sırası da bilinmez; önerilen numara uydurma olurdu. Numaralar weld map'ten elle girilir (`kaynak_no_bos` engeli).
 */
export function kaynakNumaralari(t) {
    if (numaraOnerilmezMi(t))
        return new Map();
    const etkin = t.kesimler.filter(etkinMi);
    const ekKonumu = etkin.some((s) => ekKaynagiMi(s) && s.mesafeMm === null) ? ekKaynagiKonumu(t) : null;
    const sirali = etkin.sort(konumSirasi(t.referans, ekKonumu));
    return new Map(sirali.map((s, i) => [s.sira, i + 1]));
}
/** Satırın geçerli kaynak numarası: kaynakNo ?? otomatik; iptalde null. */
export function kaynakNoOf(t, sira) {
    const s = t.kesimler.find((x) => x.sira === sira);
    if (!s || !etkinMi(s))
        return null;
    return s.kaynakNo ?? kaynakNumaralari(t).get(sira) ?? null;
}
/**
 * Gövdeyi öneriyle birleştirir (sunucu ve web aynı fonksiyon): satırları siraya göre dizer, sira 1..n boşluksuz olmalı,
 * öneri satırları (1..m, m = oneri.kesimler.length) silinmemiş olmalı ve gönderilen tür ile öneri alanları öneriyle aynı olmalı
 * (bayat pencere); sira ≤ m satırlara oneriMm/oneriBaglanti (ve satır türü) öneriden yazılır, sira > m satırlarda öneri alanları
 * null. Sonra kesimleriNormallestir.
 */
export function kesimTaslagiHazirla(g, oneri) {
    const sirali = [...g.kesimler].sort((a, b) => a.sira - b.sira);
    const n = sirali.length;
    const m = oneri.kesimler.length;
    let hata = null;
    if (sirali.some((s, i) => s.sira !== i + 1))
        hata = `Cut numbers must run C1…C${n} without gaps.`;
    else if (n < m)
        hata = `The cut plan must keep every proposed cut (C1–C${m}); cancel a cut instead of removing it.`;
    // Pencere açıldıktan sonra öneri değiştiyse (yeni sürüm, başka planın onayı, yeni dönüş verisi) satırlar kişinin gördüğü
    // öneriye denk gelmez; türü ve öneri değerlerini sessizce sunucunun önerisinden yazmak, görülen bir kesimi ek kaynağına
    // çevirebilirdi. Pencere öneri alanlarını gönderir; tutmazsa plan yazılmaz.
    else if (sirali.some((s) => {
        const o = oneri.kesimler.find((x) => x.sira === s.sira);
        return o !== undefined && (s.tur !== o.tur || (s.oneriBaglanti !== undefined && s.oneriBaglanti !== o.oneriBaglanti) || (s.oneriMm !== undefined && s.oneriMm !== o.oneriMm));
    }))
        hata = "The proposal has changed since this window was opened; close the window and open the cut plan again.";
    const kesimler = sirali.map((s) => {
        const o = oneri.kesimler.find((x) => x.sira === s.sira);
        return {
            sira: s.sira,
            tur: o ? o.tur : s.tur,
            mesafeMm: s.mesafeMm,
            baglanti: s.baglanti,
            durum: s.durum,
            iptalNedeni: s.iptalNedeni,
            not: s.not,
            kaynakNo: s.kaynakNo,
            oneriMm: o ? o.oneriMm : null,
            oneriBaglanti: o ? o.oneriBaglanti : null,
            // D-070: işaret yalnız gönderildiyse taşınır (anahtarsız gövde bugünkü taslağı verir); beyanlı olup olmadığına normalleştirme bakar.
            ...(s.mesafeKayitYok === true ? { mesafeKayitYok: true } : {}),
        };
    });
    // D-070: işaretin çelişkili gönderilmesi (pencere üretmez; elle kurulmuş istek ya da yükleme betiği). Etkin satırda işaret yalnız
    // Pipe to pipe butt kesimde ya da ek kaynağında ve mesafesiz gelir. İlk hata kazanır; yukarıdaki üç denetimden sonra bakılır.
    if (hata === null) {
        for (const s of kesimler) {
            if (s.mesafeKayitYok !== true || !etkinMi(s))
                continue;
            if (!ekKaynagiMi(s) && !(s.tur === "kesim" && s.baglanti === BORU_BAGLANTI))
                hata = `${satirAdi(s)}: “No distance record available” applies only to a Pipe to pipe butt cut or a splice weld.`;
            else if (s.mesafeMm !== null)
                hata = `${satirAdi(s)}: “No distance record available” and a distance cannot be sent together.`;
            if (hata !== null)
                break;
        }
    }
    return { taslak: kesimleriNormallestir({ referans: g.referans, kesimYok: g.kesimYok, gerekce: g.gerekce, kesimler }), hata };
}
/** Konumun kusur bandının içinde olup olmadığı: aralıkta bas < x < son, noktada |x − p| < 500. */
function bantIcinde(x, bant) {
    return bant.bas === bant.son ? Math.abs(x - bant.bas) < NOKTA_PAYI_MM : bant.bas < x && x < bant.son;
}
/**
 * Parçalar: etkin `kesim` satırları konuma göre dizilir, (1,2),(3,4)… eşlenir. Sayı tekse: önerinin Box ve Pin satırları arasına
 * yalnız elle eklenmiş Pipe to pipe satırları girmişse (D-054: iki flanş kesimli plana tek kesim eklenmiş; öneri alanı boş satır
 * elle eklenmiştir) son Pipe to pipe eşsiz kalır, öbürleri eşlenir; değilse ilk satır Box ise tek başına durur (flanş değişimi,
 * boru parçası yok); değilse son satır Pin ise o tek başına durur; o da değilse son Pipe to pipe eşsiz kalır.
 * D-070: beyanlı bir kesim varken (kesim yerleri eksik) parça da eşsiz satır da türetilmez: beyanlı satır eşlemeden düşseydi kalan
 * satırlar kendi aralarında eşlenir, hiç değişmemiş bir parça taranırdı (700, [beyanlı], 8,000, 17,500 → 700–8,000). Parçalar bilinmez,
 * yok değildir; şema taraması, özet, "Replaced pieces" ve monitörün "new pipe ≈" kısmı buradan beslenir.
 */
function parcalariKur(t) {
    if (kesimKonumuEksikMi(t))
        return { parcalar: [], esizler: [] };
    const r = t.referans;
    let dizi = t.kesimler.filter((s) => etkinMi(s) && s.tur === "kesim" && kesimKonumu(s, r) !== null).sort(konumSirasi(r));
    const esizler = [];
    if (dizi.length % 2 === 1) {
        const ilk = dizi[0];
        const son = dizi[dizi.length - 1];
        // D-054: Box…Pin önerisine eklenen kesim; önerinin kendi Pipe to pipe satırı varsa (karışık iş) bugünkü kural geçerli.
        const elleEklenmis = dizi.length > 2 && dizi.slice(1, -1).every((s) => s.baglanti === BORU_BAGLANTI && s.oneriBaglanti === null);
        if (boxMu(ilk.baglanti) && ilk.oneriBaglanti === BOX_BAGLANTI && pinMi(son.baglanti) && son.oneriBaglanti === PIN_BAGLANTI && elleEklenmis) {
            const sonBoru = dizi.length - 2;
            esizler.push(dizi[sonBoru].sira);
            dizi = dizi.filter((_, i) => i !== sonBoru);
        }
        else if (boxMu(ilk.baglanti))
            dizi = dizi.slice(1);
        else if (pinMi(son.baglanti))
            dizi = dizi.slice(0, -1);
        else {
            esizler.push(son.sira);
            dizi = dizi.slice(0, -1);
        }
    }
    const parcalar = [];
    for (let i = 0; i + 1 < dizi.length; i += 2) {
        const a = dizi[i];
        const b = dizi[i + 1];
        parcalar.push({ bas: kesimKonumu(a, r), son: kesimKonumu(b, r), basSira: a.sira, sonSira: b.sira });
    }
    return { parcalar, esizler };
}
/** Engel, uyarı ve ipuçları (kurallar dosya başında ve aşağıda sırasıyla). Önce kesimleriNormallestir. */
export function kesimPlaniniDegerlendir(taslak, b) {
    const t = kesimleriNormallestir(taslak);
    const r = t.referans;
    const boxPos = boxKonumu(r);
    const pinPos = pinKonumu(r);
    const etkin = t.kesimler.filter(etkinMi);
    const engeller = [];
    const uyarilar = [];
    const ipuclari = [];
    // 1–2. Kesimsiz plan "No cut" beyanı ister; beyan varken etkin satır kalamaz.
    if (!t.kesimYok && etkin.length === 0)
        engeller.push({ tur: "kesim_yok_beyansiz" });
    if (t.kesimYok && etkin.length > 0)
        engeller.push({ tur: "kesim_yok_kesimli", sira: etkin[0].sira });
    // 3. Pipe to pipe kesimde mesafe ya da "No distance record available" beyanı zorunlu (D-055: ek kaynağında mesafe isteğe bağlı;
    //    D-070: beyanlı satır engel almaz. Pipe to pipe bağlantıyla gönderilen kaynak tamiri satırı beyan taşıyamaz, engeli alır).
    for (const s of etkin)
        if (s.baglanti === BORU_BAGLANTI && s.mesafeMm === null && !ekKaynagiMi(s) && !mesafeBeyanliMi(s))
            engeller.push({ tur: "mesafe_bos", sira: s.sira });
    // 4. Mesafe (girilmişse; ek kaynağı dahil) 0 ile boy arasında.
    for (const s of etkin) {
        if (s.mesafeMm !== null && (s.mesafeMm < 0 || (r.boy !== null && s.mesafeMm > r.boy)))
            engeller.push({ tur: "aralik_disi", sira: s.sira, mesafeMm: s.mesafeMm, boy: r.boy });
    }
    // 5. Bu planda aynı konumda iki etkin satır (Pipe to pipe kesim box flanş kaynağının mesafesindeyse Box satırıyla çakışır).
    const gorulen = new Map();
    for (const s of etkin) {
        const anahtar = boxMu(s.baglanti) ? String(r.box ?? "box") : pinMi(s.baglanti) ? String(r.pin ?? "pin") : s.mesafeMm === null ? null : String(s.mesafeMm);
        if (anahtar === null)
            continue;
        const onceki = gorulen.get(anahtar);
        if (!onceki) {
            gorulen.set(anahtar, s);
            continue;
        }
        const flans = boxMu(onceki.baglanti) || boxMu(s.baglanti) ? "box" : pinMi(onceki.baglanti) || pinMi(s.baglanti) ? "pin" : null;
        const mm = Number(anahtar);
        engeller.push({ tur: "ayni_mesafe", a: onceki.sira, b: s.sira, mesafeMm: Number.isFinite(mm) ? mm : null, flans });
    }
    // 6. D-043: iptal, birleştirme ya da "No cut" gerekçesi isteğe bağlıdır; engel değildir.
    // 7. Kusur bandının içindeki kesim yalnız uyarıdır (D-043: kesim notu isteğe bağlı, engel değil).
    for (const s of etkin) {
        if (s.tur !== "kesim")
            continue;
        const x = kesimKonumu(s, r);
        if (x === null)
            continue;
        const bant = b.bantlar.find((k) => bantIcinde(x, k));
        if (!bant)
            continue;
        uyarilar.push({ tur: "kusur_bandi", sira: s.sira, mesafeMm: x, bant });
    }
    // 8. Kaynak numarası: tam sayı ≥ 1, planda tekil. D-070: planda beyanlı satır varsa numara önerilmez (oto boş): numarası
    //    girilmemiş etkin satırların hepsi TEK engelde sayılır (kaynak_no_bos); girilmiş numara bugünkü kurallarla denetlenir.
    const numaraYazilir = numaraOnerilmezMi(t);
    const oto = kaynakNumaralari(t);
    const nolar = new Map();
    const numarasizlar = numaraYazilir ? etkin.filter((s) => s.kaynakNo === null).map((s) => s.sira) : [];
    if (numarasizlar.length)
        engeller.push({ tur: "kaynak_no_bos", siralar: numarasizlar });
    for (const s of etkin) {
        if (numaraYazilir && s.kaynakNo === null)
            continue;
        const no = s.kaynakNo ?? oto.get(s.sira) ?? null;
        if (no === null || !Number.isInteger(no) || no < 1) {
            engeller.push({ tur: "kaynak_no", sira: s.sira });
            continue;
        }
        nolar.set(no, (nolar.get(no) ?? 0) + 1);
    }
    for (const [no, adet] of nolar)
        if (adet > 1)
            engeller.push({ tur: "kaynak_no_tekrar", no });
    // 9. Referans: tam mm, 0 ile boy arası, box flanş kaynağı pin flanş kaynağından önce.
    const degerler = [r.box, r.pin, r.boy, ...r.ara].filter((x) => x !== null);
    const refBozuk = degerler.some((x) => !Number.isInteger(x) || x < 0) ||
        (r.boy !== null && [r.box, r.pin, ...r.ara].some((x) => x !== null && x > r.boy)) ||
        (r.box !== null && r.pin !== null && r.box >= r.pin);
    if (refBozuk)
        engeller.push({ tur: "referans" });
    // Parçalar ve parça uyarıları.
    const { parcalar, esizler } = parcalariKur(t);
    const satir = (sira) => t.kesimler.find((s) => s.sira === sira);
    for (const sira of esizler)
        uyarilar.push({ tur: "esiz", sira });
    const ilkParca = parcalar[0];
    if (ilkParca && satir(ilkParca.basSira).baglanti === BORU_BAGLANTI) {
        const artik = ilkParca.bas - boxPos;
        if (artik > 0 && artik < KISA_ARTIK_MM)
            uyarilar.push({ tur: "kisa_artik", taraf: "box", sira: ilkParca.basSira, artikMm: artik, refMm: r.box, mesafeMm: ilkParca.bas });
    }
    const sonParca = parcalar[parcalar.length - 1];
    if (sonParca && satir(sonParca.sonSira).baglanti === BORU_BAGLANTI) {
        const artik = pinPos - sonParca.son;
        if (artik > 0 && artik < KISA_ARTIK_MM)
            uyarilar.push({ tur: "kisa_artik", taraf: "pin", sira: sonParca.sonSira, artikMm: artik, refMm: r.pin, mesafeMm: sonParca.son });
    }
    for (let i = 0; i + 1 < parcalar.length; i++) {
        const a = parcalar[i];
        const c = parcalar[i + 1];
        const bosluk = c.bas - a.son;
        if (bosluk > 0 && bosluk < KISA_ARTIK_MM)
            uyarilar.push({ tur: "kisa_artik_ara", sira: a.sonSira, ile: c.basSira, artikMm: bosluk, aMm: a.son, bMm: c.bas });
        if (bosluk > 0 && bosluk < BIRLESTIRME_ESIGI_MM) {
            ipuclari.push({ tur: "birlestir", sira: a.sonSira, ile: c.basSira, saglamMm: bosluk, ilk: true });
            ipuclari.push({ tur: "birlestir", sira: c.basSira, ile: a.sonSira, saglamMm: bosluk, ilk: false });
        }
    }
    // D-055: ek kaynağı yeni borudadır: planda değişecek parça yoksa uyarı; mesafesi girilmişse bir parçanın içinde olmalı (yalnız uyarı).
    // D-070: kesim yerleri eksikken parçalar bilinmez (yok değildir); iki ek kaynağı uyarısı da verilmez.
    const konumEksik = kesimKonumuEksikMi(t);
    for (const s of etkin) {
        if (!ekKaynagiMi(s) || konumEksik)
            continue;
        if (parcalar.length === 0)
            uyarilar.push({ tur: "ek_parcasiz", sira: s.sira });
        else if (s.mesafeMm !== null && !parcalar.some((p) => p.bas < s.mesafeMm && s.mesafeMm < p.son))
            uyarilar.push({ tur: "ek_parca_disi", sira: s.sira, mesafeMm: s.mesafeMm });
    }
    // Başka işin onaylı kesimine 500 mm'den yakın Pipe to pipe kesim (yalnız uyarı; kalemler arası engel yok, Soru 2). Ek kaynağı kesim değil.
    const mesafeliBoruKesimi = (s) => s.baglanti === BORU_BAGLANTI && s.mesafeMm !== null && !ekKaynagiMi(s);
    for (const s of etkin) {
        if (!mesafeliBoruKesimi(s))
            continue;
        const d = (b.digerKesimler ?? []).find((k) => Math.abs(k.mesafeMm - s.mesafeMm) < FLANS_ESIGI_MM);
        if (d)
            uyarilar.push({ tur: "diger_plan_yakin", sira: s.sira, mesafeMm: s.mesafeMm, etiket: d.etiket, digerMm: d.mesafeMm });
    }
    // D-070: öteki kalemin onaylı planında mesafe kaydı olmayan kesim varsa ve bu planda yakınlığı denetlenecek (mesafeli Pipe to pipe)
    // bir kesim varsa, denetlenemeyen yakınlık söylenir (öteki kalem başına bir uyarı).
    if (etkin.some(mesafeliBoruKesimi)) {
        for (const d of b.digerMesafesiz ?? [])
            if (d.adet > 0)
                uyarilar.push({ tur: "diger_plan_mesafesiz", etiket: d.etiket, adet: d.adet });
    }
    // D-070: bu planın beyanlı satırları (plan başına bir uyarı).
    const beyanlilar = etkin.filter(mesafeBeyanliMi).map((s) => s.sira);
    if (beyanlilar.length)
        uyarilar.push({ tur: "mesafe_kaydi_yok", siralar: beyanlilar });
    if (b.hidrolik)
        uyarilar.push({ tur: "hidrolik", rotaKod: b.rotaKod });
    // Flanş kaynağına yakın Pipe to pipe kesim → "Cut at … flange weld".
    for (const s of etkin) {
        if (s.tur !== "kesim" || s.baglanti !== BORU_BAGLANTI || s.mesafeMm === null)
            continue;
        const x = s.mesafeMm;
        if (x < boxPos + FLANS_ESIGI_MM)
            ipuclari.push({ tur: "flans_yakin", sira: s.sira, taraf: "box", kalanMm: Math.max(0, x - boxPos), refMm: r.box });
        else if (x > pinPos - FLANS_ESIGI_MM)
            ipuclari.push({ tur: "flans_yakin", sira: s.sira, taraf: "pin", kalanMm: Math.max(0, pinPos - x), refMm: r.pin });
    }
    return {
        engeller,
        uyarilar,
        ipuclari,
        parcalar,
        yeniBoruMm: parcalar.reduce((n, p) => n + (p.son - p.bas), 0),
        etkinKesim: etkin.filter((s) => s.tur === "kesim").length,
        kaynakSayisi: etkin.length,
        ekKaynagi: etkin.filter(ekKaynagiMi).length,
        iptal: t.kesimler.length - etkin.length,
        mesafesiz: beyanlilar.length,
    };
}
/** mm metni: binlik ayraç virgül ("8,000"); en-US gösterimiyle aynı, ICU'ya bağlı değil. */
export const mmMetni = (n) => {
    const [tam, kesir] = String(Math.abs(n)).split(".");
    return (n < 0 ? "-" : "") + (tam ?? "").replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (kesir ? "." + kesir : "");
};
/** "1,000–3,000" | "7,500" */
export const konumMetni = (k) => (k.bas === k.son ? mmMetni(k.bas) : `${mmMetni(k.bas)}–${mmMetni(k.son)}`);
/** "5m" | "0.5m–3.5m" ("Not cut points: … (5m, 20m)" için) */
export const metreMetni = (k) => {
    const m = (x) => `${Math.round(x) / 1000}m`;
    return k.bas === k.son ? m(k.bas) : `${m(k.bas)}–${m(k.son)}`;
};
/**
 * Engel metni (İngilizce): sunucunun 400 yanıtı ve web (cevir kalıbıyla). `etiket` (D-055): satırın adı, `satirEtiketi(taslak)`;
 * verilmezse "C{sira}".
 */
export function engelMetni(e, etiket = varsayilanEtiket) {
    switch (e.tur) {
        case "kesim_yok_beyansiz":
            return "No active cut: add a cut point or choose No cut.";
        case "kesim_yok_kesimli":
            return `No cut is chosen but ${etiket(e.sira)} is still active; cancel it or undo No cut.`;
        case "mesafe_bos":
            // D-070: cümle çıkış yolunu da söyler (mesafeyi veren kayıt yoksa beyan).
            return `${etiket(e.sira)}: a Pipe to pipe butt cut needs a distance from the box end; if no record gives it, tick “No distance record available”.`;
        case "aralik_disi":
            return e.boy !== null
                ? `${etiket(e.sira)}: ${mmMetni(e.mesafeMm)} mm is outside 0 to the tube length (${mmMetni(e.boy)} mm).`
                : `${etiket(e.sira)}: ${mmMetni(e.mesafeMm)} mm is below 0.`;
        case "ayni_mesafe":
            return e.flans
                ? `${etiket(e.a)} and ${etiket(e.b)} are both at the ${e.flans} flange weld.`
                : `${etiket(e.a)} and ${etiket(e.b)} are at the same distance (${mmMetni(e.mesafeMm ?? 0)} mm).`;
        case "kaynak_no":
            return `${etiket(e.sira)}: the weld number must be a whole number of 1 or more.`;
        case "kaynak_no_bos":
            // D-070: satırlar ", " ile birleşir ("and" yok): yakalanan değerin içinde çevrilmeyen sözcük kalmaz.
            return `Type the weld number of ${e.siralar.map(etiket).join(", ")} as written on the weld map; weld numbers are not proposed while a row has no distance record.`;
        case "kaynak_no_tekrar":
            return `Weld number W${e.no} is used twice.`;
        case "referans":
            return "Tube reference: values must be whole millimetres from 0 up to the tube length, box flange weld before pin flange weld.";
    }
}
/** Uyarı metni (İngilizce). `etiket` (D-055) engelMetni'ndeki gibi; ek kaynağı uyarıları satırı hep "S{sira}" diye anar. */
export function uyariMetni(u, etiket = varsayilanEtiket) {
    switch (u.tur) {
        case "kusur_bandi":
            return `${etiket(u.sira)} at ${mmMetni(u.mesafeMm)} mm is inside a defect zone (${konumMetni(u.bant)} mm).`;
        case "esiz":
            return `${etiket(u.sira)}: a pipe to pipe cut without a pair.`;
        case "kisa_artik": {
            const c = etiket(u.sira);
            if (u.taraf === "box") {
                return u.refMm !== null
                    ? `${c}: ${mmMetni(u.artikMm)} mm remnant between the box flange weld (${mmMetni(u.refMm)}) and ${c} (${mmMetni(u.mesafeMm)}), shorter than 500 mm.`
                    : `${c}: ${mmMetni(u.artikMm)} mm remnant between the box end and ${c} (${mmMetni(u.mesafeMm)}), shorter than 500 mm.`;
            }
            return u.refMm !== null
                ? `${c}: ${mmMetni(u.artikMm)} mm remnant between ${c} (${mmMetni(u.mesafeMm)}) and the pin flange weld (${mmMetni(u.refMm)}), shorter than 500 mm.`
                : `${c}: ${mmMetni(u.artikMm)} mm remnant between ${c} (${mmMetni(u.mesafeMm)}) and the pin end, shorter than 500 mm.`;
        }
        case "kisa_artik_ara":
            return `${mmMetni(u.artikMm)} mm remnant between ${etiket(u.sira)} (${mmMetni(u.aMm)}) and ${etiket(u.ile)} (${mmMetni(u.bMm)}), shorter than 500 mm.`;
        case "diger_plan_yakin":
            return `${etiket(u.sira)} at ${mmMetni(u.mesafeMm)} mm is within 500 mm of an approved cut of ${u.etiket} (${mmMetni(u.digerMm)} mm).`;
        case "hidrolik":
            return `Hydraulic line item on the ${u.rotaKod} route; the WPS list and steps of this route are not made for hydraulic lines.`;
        case "ek_parca_disi":
            return `S${u.sira} at ${mmMetni(u.mesafeMm)} mm is outside the pieces to be replaced.`;
        case "ek_parcasiz":
            return `S${u.sira}: a splice weld in a plan without a piece to be replaced.`;
        case "mesafe_kaydi_yok":
            return `No distance record: ${u.siralar.map(etiket).join(", ")}. These rows are not drawn on the schematic and are not checked by position (defect zone, pair, short remnant, other items' cuts). Pieces to replace and new pipe length are calculated only when every cut has a distance.`;
        case "diger_plan_mesafesiz":
            return u.adet === 1
                ? `The approved cut plan of ${u.etiket} has 1 cut without a distance record; nearness to it cannot be checked.`
                : `The approved cut plan of ${u.etiket} has ${u.adet} cuts without a distance record; nearness to them cannot be checked.`;
    }
}
/** İpucu metni (İngilizce); düğme metinleri ("Cut at box flange weld", "Merge C2–C3") web'dedir. `etiket` engelMetni'ndeki gibi. */
export function ipucuMetni(i, etiket = varsayilanEtiket) {
    if (i.tur === "flans_yakin") {
        if (i.taraf === "box")
            return i.refMm !== null ? `Only ${mmMetni(i.kalanMm)} mm left after box flange weld (${mmMetni(i.refMm)})` : `Only ${mmMetni(i.kalanMm)} mm from the box end`;
        return i.refMm !== null ? `Only ${mmMetni(i.kalanMm)} mm left before pin flange weld (${mmMetni(i.refMm)})` : `Only ${mmMetni(i.kalanMm)} mm from the pin end`;
    }
    return i.ilk ? `${mmMetni(i.saglamMm)} mm sound pipe to ${etiket(i.ile)}` : `see ${etiket(i.ile)}: Merge ${etiket(i.ile)}–${etiket(i.sira)}`;
}
/**
 * [sol, sağ] ana malzeme: Box/Pin to pipe = [flanş, boru], Pipe to pipe = [boru, boru].
 * MB 4130 (100 ksi) / API 5L X80 (R002 QAF 038); CKB ve H bugünkü yer tutucu değerleri; hidrolik hat MB/CKB rotasında da
 * 316L (varsayım: hidrolik kalemler bugün MB/CKB rotasına iniyor, X80 yanlış olurdu).
 */
export function kaynakMalzemesi(joint, b) {
    const hidrolik = b.hat === "Hydraulic";
    const boru = hidrolik ? "316L SS" : b.rotaKod === "MB" ? "API 5L X80" : b.rotaKod === "CKB" ? "AISI 4130 (75-80 ksi)" : b.rotaKod === "H" ? "316L SS" : "—";
    const flans = hidrolik ? "316L SS" : b.rotaKod === "MB" ? "4130 (100 ksi)" : b.rotaKod === "CKB" ? "AISI 4130 (75-80 ksi)" : b.rotaKod === "H" ? "316L SS" : "—";
    return joint === BORU_BAGLANTI ? [boru, boru] : [flans, boru];
}
/** Onaylı satırlar → kaynaklar (no sırasıyla). */
export function kaynaklariTuret(taslak, b) {
    const t = kesimleriNormallestir(taslak);
    const oto = kaynakNumaralari(t);
    return t.kesimler
        .filter(etkinMi)
        .map((s) => ({ kesimSira: s.sira, no: s.kaynakNo ?? oto.get(s.sira) ?? 0, joint: s.baglanti, mesafeMm: s.mesafeMm, bm: kaynakMalzemesi(s.baglanti, b) }))
        .sort((a, c) => a.no - c.no || a.kesimSira - c.kesimSira);
}
/** D-055: "1 splice weld" · "2 splice welds" (olay, monitör ve özet metinleri). */
const ekAdetMetni = (n) => `${n} splice weld${n === 1 ? "" : "s"}`;
export function kesimOzeti(taslak) {
    const t = kesimleriNormallestir(taslak);
    const onerilen = t.kesimler.filter((s) => s.oneriBaglanti !== null);
    const etkin = t.kesimler.filter(etkinMi);
    const oneri = onerilen.length;
    const iptal = onerilen.filter((s) => !etkinMi(s)).length;
    const birlestirme = t.kesimler.filter((s) => !etkinMi(s) && s.iptalNedeni === "birlestirme").length;
    const boxa = etkin.filter((s) => s.oneriBaglanti === BORU_BAGLANTI && boxMu(s.baglanti)).length;
    const pina = etkin.filter((s) => s.oneriBaglanti === BORU_BAGLANTI && pinMi(s.baglanti)).length;
    // D-070: Box / Pin önerisi Pipe to pipe butt onaylandıysa ayrı sayılır (referans boşken böyle bir plan "as proposed" okunuyordu);
    // bu satırlar ayrıca "distance changed" sayılmaz. Beyanlı satırın mesafesi yoktur: o da "distance changed" değildir.
    const boruyaMi = (s) => s.oneriBaglanti !== null && s.oneriBaglanti !== BORU_BAGLANTI && s.baglanti === BORU_BAGLANTI;
    const boruya = etkin.filter(boruyaMi).length;
    const mesafeDegisen = etkin.filter((s) => s.baglanti === BORU_BAGLANTI && s.oneriMm !== null && s.mesafeMm !== null && s.mesafeMm !== s.oneriMm && !boruyaMi(s)).length;
    const mesafesiz = etkin.filter(mesafeBeyanliMi).length;
    const eklenen = etkin.filter((s) => s.oneriBaglanti === null && !ekKaynagiMi(s)).length;
    const ekEklenen = etkin.filter((s) => s.oneriBaglanti === null && ekKaynagiMi(s)).length;
    const { parcalar } = parcalariKur(t);
    // D-070: "N without distance record" listenin son parçasıdır ("no proposal" dalında da).
    const sonMetin = [eklenen ? `${eklenen} added` : "", ekEklenen ? `${ekAdetMetni(ekEklenen)} added` : "", mesafesiz ? `${mesafesiz} without distance record` : ""].filter(Boolean);
    let detay;
    if (oneri === 0)
        detay = "no proposal" + (sonMetin.length ? `; ${sonMetin.join(", ")}` : "");
    else {
        const parcaMetin = [
            iptal ? `${iptal} cancelled` : "",
            boxa ? `${boxa} moved to box flange weld` : "",
            pina ? `${pina} moved to pin flange weld` : "",
            boruya ? `${boruya} changed to Pipe to pipe butt` : "",
            mesafeDegisen ? `${mesafeDegisen} distance changed` : "",
            ...sonMetin,
        ].filter(Boolean);
        detay = parcaMetin.length ? `proposal ${oneri}; ${parcaMetin.join(", ")}` : "as proposed";
    }
    return {
        etkinKesim: etkin.filter((s) => s.tur === "kesim").length,
        kaynakSayisi: etkin.length,
        oneri,
        iptal,
        birlestirme,
        boxa,
        pina,
        mesafeDegisen,
        eklenen,
        ekKaynagi: etkin.filter(ekKaynagiMi).length,
        oneriEk: onerilen.filter(ekKaynagiMi).length,
        ekEklenen,
        mesafesiz,
        boruya,
        parcalar,
        yeniBoruMm: parcalar.reduce((n, p) => n + (p.son - p.bas), 0),
        detay,
    };
}
/**
 * Olay/log metni. `kim` verilirse sona " — kim". D-055: ek kaynakları ayrı sayılır ("2 cuts, 1 splice weld").
 * Örnek: "Cut plan approved: R002 Main #1, 4 cuts (proposal 6; 2 cancelled, 1 moved to box flange weld) — Mustafa Ali Hançar"
 */
export function kesimOlayMetni(etiket, taslak, kim) {
    const t = kesimleriNormallestir(taslak);
    const o = kesimOzeti(t);
    const etkin = t.kesimler.filter(etkinMi);
    const kesim = etkin.filter((s) => s.tur === "kesim").length;
    const ek = etkin.filter(ekKaynagiMi).length;
    const tamir = etkin.length - kesim - ek;
    const parcalar = [
        kesim ? `${kesim} cut${kesim === 1 ? "" : "s"}` : "",
        tamir ? `${tamir} weld repair${tamir === 1 ? "" : "s"}` : "",
        ek ? ekAdetMetni(ek) : "",
    ].filter(Boolean);
    const kesimler = t.kesimYok || etkin.length === 0 ? "no cut" : parcalar.join(", ");
    return `Cut plan approved: ${etiket}, ${kesimler} (${o.detay})${kim ? ` — ${kim}` : ""}`;
}
/**
 * "CUTTING MONITOR — 630 (box flange weld) · 8,000 · 16,500 · 17,500 mm from box end · approved by Mustafa Ali Hançar · 29.09.2026 · new pipe ≈ 8,370 mm".
 * D-055: ek kaynakları kesim yerleri arasında yazılmaz; sona " · 1 splice weld on the new pipe" eklenir.
 * D-070: beyanlı kesimler yer listesinden çıkar, listeden sonra kaynak numaralarıyla (numara sırasıyla) anılır:
 * "CUTTING MONITOR — no distance record: W2, W3 · approved by …" · "… — 22,230 (pin flange weld) mm from box end · no distance record: W1, W2, W3 · approved by …" ·
 * "… — pin flange weld · no distance record: W1, W2, W3 · approved by …". Beyanlı ek kaynağı bugünkü gibi yalnız sondaki sayıda anılır.
 * Kesim yerleri eksikken "new pipe ≈" yazılmaz (parçalar türetilmez). Mesafe sonradan girilince kaynak yer listesine geçer.
 */
export function kesimMonitorMetni(p) {
    const t = kesimleriNormallestir(p.taslak);
    const etkinler = t.kesimler.filter(etkinMi);
    const ek = etkinler.filter(ekKaynagiMi).length;
    const ekMetin = ek ? ` · ${ekAdetMetni(ek)} on the new pipe` : "";
    const kesimler = etkinler.filter((s) => !ekKaynagiMi(s));
    if (t.kesimYok || kesimler.length === 0)
        return `CUTTING MONITOR — No cut · approved by ${p.onaylayan} · ${p.tarih}${t.gerekce ? ` · reason: ${t.gerekce}` : ""}${ekMetin}`;
    const etkin = kesimler.filter((s) => !mesafeBeyanliMi(s)).sort(konumSirasi(t.referans));
    // Beyanlı kesimler: kaynak numarasıyla, numara sırasında (numarası olmayan taslak satırı satır adıyla, sona).
    const beyanlilar = kesimler
        .filter(mesafeBeyanliMi)
        .sort((a, b) => (a.kaynakNo ?? Number.POSITIVE_INFINITY) - (b.kaynakNo ?? Number.POSITIVE_INFINITY) || a.sira - b.sira)
        .map((s) => (s.kaynakNo !== null ? `W${s.kaynakNo}` : satirAdi(s)));
    const parca = (s) => {
        const flans = boxMu(s.baglanti) ? "box flange weld" : pinMi(s.baglanti) ? "pin flange weld" : null;
        const mm = s.mesafeMm !== null ? mmMetni(s.mesafeMm) : null;
        if (s.tur === "kaynak_tamiri")
            return `${mm ?? flans ?? "—"} (weld repair)`;
        if (flans)
            return mm !== null ? `${mm} (${flans})` : flans;
        return mm ?? "—";
    };
    const { yeniBoruMm } = kesimOzeti(t);
    // Hiçbir satır mesafe taşımıyorsa (ör. referanssız pin flanş kaynağı) "mm from box end" yazılmaz.
    const birim = etkin.some((s) => s.mesafeMm !== null) ? " mm from box end" : "";
    const yerler = [etkin.length ? `${etkin.map(parca).join(" · ")}${birim}` : "", beyanlilar.length ? `no distance record: ${beyanlilar.join(", ")}` : ""].filter(Boolean).join(" · ");
    return `CUTTING MONITOR — ${yerler} · approved by ${p.onaylayan} · ${p.tarih}${yeniBoruMm > 0 ? ` · new pipe ≈ ${mmMetni(yeniBoruMm)} mm` : ""}${ekMetin}`;
}
/**
 * D-070: onaydan sonra beyanlı satıra girilecek mesafenin engelleri (sunucu ve web aynı kural). Aday değeri `sira` satırına koyar,
 * planı boş bağlamla değerlendirir ve yalnız o satırın aralık engelini (`aralik_disi`) ile onu anan aynı mesafe engellerini
 * (`ayni_mesafe`) döner; uyarı döndürmez (sonradan giriş var olan bir kesimi kaydeder, kesim planlamaz). Tam sayı denetimi çağırandadır.
 * Boyu boş planda yalnız "0'ın altı" engeli doğabilir. Box / Pin flanş kaynağının referans mesafesi o satırla çakışır.
 * Metin: `engelMetni(e, satirEtiketi(t))`.
 */
export function mesafeDoldurmaEngelleri(t, sira, mm) {
    const kesimler = t.kesimler.map((s) => {
        if (s.sira !== sira)
            return s;
        const { mesafeKayitYok: _beyan, ...kalan } = s;
        return { ...kalan, mesafeMm: mm };
    });
    const d = kesimPlaniniDegerlendir({ ...t, kesimler }, { bantlar: [], hidrolik: false, rotaKod: "" });
    return d.engeller.filter((e) => (e.tur === "aralik_disi" && e.sira === sira) || (e.tur === "ayni_mesafe" && (e.a === sira || e.b === sira)));
}
//# sourceMappingURL=kesim-plani.js.map